import { render, staticRenderFns } from "./MigrationMemberList.vue?vue&type=template&id=0a1ec3ee&scoped=true&"
import script from "./MigrationMemberList.vue?vue&type=script&lang=js&"
export * from "./MigrationMemberList.vue?vue&type=script&lang=js&"
import style0 from "./MigrationMemberList.vue?vue&type=style&index=0&id=0a1ec3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1ec3ee",
  null
  
)

export default component.exports